// @flow
import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import type { ComparedMetric } from 'statsradio/modules/dashboard/domain/DashboardData';
import ReachMetric from './ReachMetric';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-around;
  align-items: center;
  margin-top: ${({ theme }) => theme.V3.metrics.margin.normal}px;
  margin-bottom: ${({ theme }) => theme.V3.metrics.margin.normal}px;
  padding-left: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

interface Props {
  cumulativeReach: number | ComparedMetric;
  averageQuarterHourReach: number | ComparedMetric;
  t: any;
}

function ReachMetrics({ cumulativeReach, averageQuarterHourReach, t }: Props) {
  return (
    <Container>
      <ReachMetric title={t('reach')} value={cumulativeReach} />
      <ReachMetric title={t('averageQuarterHourV2')} value={averageQuarterHourReach} />
    </Container>
  );
}

export default translate('metrics')(ReachMetrics);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/ReachMetrics.js